/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocationPaymentEvent } from './LocationPaymentEvent';
import {
    instanceOfLocationPaymentEvent,
    LocationPaymentEventFromJSON,
    LocationPaymentEventFromJSONTyped,
    LocationPaymentEventToJSON,
} from './LocationPaymentEvent';
import type { TerminalStateEvent } from './TerminalStateEvent';
import {
    instanceOfTerminalStateEvent,
    TerminalStateEventFromJSON,
    TerminalStateEventFromJSONTyped,
    TerminalStateEventToJSON,
} from './TerminalStateEvent';

/**
 * @type StreamTerminalEvents200Response
 * 
 * @export
 */
export type StreamTerminalEvents200Response = LocationPaymentEvent | TerminalStateEvent;

export function StreamTerminalEvents200ResponseFromJSON(json: any): StreamTerminalEvents200Response {
    return StreamTerminalEvents200ResponseFromJSONTyped(json, false);
}

export function StreamTerminalEvents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamTerminalEvents200Response {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfLocationPaymentEvent(json)) {
        return LocationPaymentEventFromJSONTyped(json, true);
    }
    if (instanceOfTerminalStateEvent(json)) {
        return TerminalStateEventFromJSONTyped(json, true);
    }
    return {} as any;
}

export function StreamTerminalEvents200ResponseToJSON(json: any): any {
    return StreamTerminalEvents200ResponseToJSONTyped(json, false);
}

export function StreamTerminalEvents200ResponseToJSONTyped(value?: StreamTerminalEvents200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfLocationPaymentEvent(value)) {
        return LocationPaymentEventToJSON(value as LocationPaymentEvent);
    }
    if (instanceOfTerminalStateEvent(value)) {
        return TerminalStateEventToJSON(value as TerminalStateEvent);
    }
    return {};
}

